import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  loading: {
    id: 'jutro-components.widgets.InlineLoader.loading',
    defaultMessage: 'Loading'
  }
});